const shortUtcCalendarDate = new Intl.DateTimeFormat("en-GB", {
  dateStyle: "medium",
  // The day is a calendar day, so it is read and shown at midnight UTC.
  timeZone: "UTC",
});

/** A UK calendar day, `YYYY-MM-DD`, short, as "4 Feb 2027", where room is tight. */
export const shortCalendarDayText = (day: string): string =>
  shortUtcCalendarDate.format(new Date(day));
